// @flow

import bowser from 'bowser';
import {setOffsetToDOMNodes} from './setOffsetToDOMNodes';
import {tableHeaderModificators} from '../constants';

const getStickyHeaders = (elementsArray: Array<HTMLElement>) => {
    const elements: Array<HTMLElement> = ((elementsArray.length > 0 ?
        elementsArray.map(el => el.nextElementSibling).filter(Boolean) : []): any);
    return elements;
};

export const isSafari = (): boolean => bowser.safari;

export const setSafariHeadersPosition = (tableId: string, scrollableRef: ?HTMLElement, currentScrollOffset: number) => {
    /*
     *  Fixed sticky header behavior on scroll left / right
     */
    if (isSafari()) {
        const dataTable = document.querySelector(`#${tableId}`);

        if (dataTable && scrollableRef) {
            const leftHeaders = dataTable.querySelectorAll(`.${tableHeaderModificators.leftHeaders}`);
            const rightHeaders = dataTable.querySelectorAll(`.${tableHeaderModificators.rightHeaders}`);
            const rightPartOffset = scrollableRef.getBoundingClientRect().left;

            const leftPartHeaders = getStickyHeaders([...leftHeaders]);
            const rightPartHeaders = getStickyHeaders([...rightHeaders]);

            setOffsetToDOMNodes(
                rightPartHeaders, rightPartOffset + currentScrollOffset
            );
            setOffsetToDOMNodes(leftPartHeaders, leftHeaders.length > 0 ?
                leftHeaders[0].getBoundingClientRect().left : 0);
        }
    }
};
